import { css } from '@emotion/react';

const base = css`
    display: flex;
    align-items: center;
    padding: 0 56px;
    height: 64px;

    .ant-breadcrumb-link {
        color: #a7a7a7;
    }

    @media (min-width: 320px) and (max-width: 480px) {
        padding: 0 16px;
        height: 38px;
    }
`;

const clickableItem = css`
    color: #a7a7a7;
`;

const styles = {
    base,
    clickableItem,
};

export default styles;
